import Icon from 'components/Icon/Icon'
import { useEffect, useState } from 'react'
import Api from 'services/api'
import './DocumentPopUp.scss'
import hocDocumentPopUp from './hocDocumentPopUp'

function DocumentPopUp({ slug, setSlug }) {
    const [data, setData] = useState(null)
    useEffect(() => {
        const API = new Api()
        const getGDPR = async () => {
            const responseGql = await API.getGDPRdata(slug)
            setData(responseGql?.data?.data?.data?.entry?.componentsBuilder[0]?.html)
        }
        getGDPR()
    }, [slug])
    if (slug === null) {
        return
    }
    return (
        <div className="modal-message">
            <div className="window modal-document">
                <div className="document-popup-header">
                    <Icon name={'cross'} className={'cross'} role={'button'} onClick={() => setSlug({ slug: null })} />
                </div>
                <div className={'text'} dangerouslySetInnerHTML={{ __html: data }} />
            </div>
        </div>
    )
}

export default hocDocumentPopUp(DocumentPopUp)
